
import { ApiProperty } from '@nestjs/swagger';
import {IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';

export class ProcurementTypesDto {
    @ApiProperty()
    procurementTypeId:Number;
    @ApiProperty()
    @IsNotEmpty({message:"Procurement Type should not be empty"})
    procurementType:string;
    @ApiProperty()
    createdAt: Date;
    @ApiProperty()
    createdUser: string | null;
    @ApiProperty()
    updatedAt: Date;
    @ApiProperty()
    updatedUser: string | null;
    @ApiProperty()
    status:boolean;
    @ApiProperty()
    versionFlag:number
}

export const ProcurementTypesDtoDefault : ProcurementTypesDto = {
    procurementTypeId:null,
    procurementType: "",
    createdUser:"",
    updatedUser:"",
    status: true,
    createdAt : new Date() ,
    updatedAt : new Date() ,
    versionFlag : 0 ,
};

